import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { TranslocoService } from '@jsverse/transloco';
import { Observable, catchError, map, of, startWith } from 'rxjs';
import { SKIP_TOKEN } from '../../data-access-authentication';
import { GeocoderPrediction } from '../model/geocoder-prediction.model';

@Injectable()
export class MapsService {
  private readonly http = inject(HttpClient);
  private readonly translocoService = inject(TranslocoService);

  private readonly baseUrl = environment.google.placesBaseUrl;

  autocompletePlaces(input: string): Observable<{ loading: boolean; predictions: GeocoderPrediction[] }> {
    if (!input) {
      return of({ loading: false, predictions: [] });
    }

    return this.http
      .post<{ places: GeocoderPrediction[] }>(
        `${this.baseUrl}/places:searchText`,
        {
          textQuery: input,
          includedType: 'locality',
          languageCode: this.translocoService.getActiveLang(),
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': environment.google.placesApiKey,
            'X-Goog-FieldMask': 'places.formattedAddress,places.addressComponents,places.displayName',
          },
          context: new HttpContext().set(SKIP_TOKEN, true),
        },
      )
      .pipe(
        map((response) => ({
          loading: false,
          predictions: (response.places || []).map((suggestion) => ({
            displayName: suggestion.displayName,
            formattedAddress: suggestion.formattedAddress,
            addressComponents: suggestion.addressComponents,
          })),
        })),
        catchError((error) => {
          console.error('Autocomplete error:', error);
          return of({ loading: false, predictions: [] });
        }),
        startWith({ loading: true, predictions: [] }),
      );
  }
}
